// Page Transitions - Fade out/in on navigation
class PageTransitions {
  constructor() {
    this.duration = 400; // Duration in milliseconds
    this.isTransitioning = false;
    this.pendingUrl = null;
    this.init();
  }

  init() {
    // Fade in on page load
    this.fadeIn();

    // Intercept link clicks
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a');

      // Skip if:
      // - Not a link
      // - External link
      // - Has target="_blank"
      // - Has download attribute
      // - Is a hash link on same page
      if (
        !link ||
        link.hostname !== window.location.hostname ||
        link.target === '_blank' ||
        link.hasAttribute('download') ||
        (link.pathname === window.location.pathname && link.hash)
      ) {
        return;
      }

      // Don't intercept cart drawer, popover, or dialog links
      if (
        link.hasAttribute('popovertarget') ||
        link.closest('dialog') ||
        link.closest('[role="dialog"]') ||
        link.getAttribute('on:click')?.includes('dialog')
      ) {
        return;
      }

      // If already transitioning, navigate immediately
      if (this.isTransitioning) {
        if (this.pendingUrl) {
          window.location.href = this.pendingUrl;
        }
        return;
      }

      e.preventDefault();
      this.navigateTo(link.href);
    });

    // Handle browser back/forward (bfcache restore)
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
        this.isTransitioning = false;
        this.pendingUrl = null;
        this.fadeIn();
      }
    });

    // Fallback for browsers that don't use bfcache
    window.addEventListener('popstate', () => {
      this.isTransitioning = false;
      this.pendingUrl = null;
      this.fadeIn();
    });
  }

  navigateTo(url) {
    this.isTransitioning = true;
    this.pendingUrl = url;

    const mainContent = document.getElementById('MainContent');
    if (!mainContent) {
      window.location.href = url;
      return;
    }

    // Listen for transition end
    const onEnd = () => {
      mainContent.removeEventListener('transitionend', onEnd);
      clearTimeout(fallback);
      window.location.href = url;
    };

    // Safety fallback in case transitionend doesn't fire
    const fallback = setTimeout(onEnd, this.duration + 50);

    mainContent.addEventListener('transitionend', onEnd, { once: true });
    mainContent.style.transition = `opacity ${this.duration}ms ease`;
    mainContent.style.opacity = '0';
  }

  fadeIn() {
    const mainContent = document.getElementById('MainContent');
    if (!mainContent) {
      this.isTransitioning = false;
      return;
    }

    // Start at 0 opacity
    mainContent.style.opacity = '0';

    // Force reflow
    mainContent.offsetHeight;

    // Fade in
    mainContent.style.transition = `opacity ${this.duration}ms ease`;
    mainContent.style.opacity = '1';

    // Scroll to top
    window.scrollTo(0, 0);

    // Reset transitioning state
    setTimeout(() => {
      this.isTransitioning = false;
      this.pendingUrl = null;
      mainContent.style.transition = '';
    }, this.duration);
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new PageTransitions();
  });
} else {
  new PageTransitions();
}
